var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramsFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2207_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6934 4.00146H0V31.6949H27.6934V4.00146Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2207_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2331 19.5973C12.0987 18.3537 12.0315 16.9424 12.0315 15.7994C12.0315 13.4805 12.0315 7.36377 7.89752 7.36377C3.15874 7.36377 0.201172 18.5553 0.201172 24.4705C0.201172 25.378 0.201172 29.7808 1.71356 31.1588C2.04958 31.4948 2.52001 31.7303 2.95713 31.7303C3.99909 31.7303 4.60393 31.2599 5.04105 30.9238C5.61258 30.4534 6.55344 29.7475 8.73787 29.2098C13.1406 27.7647 12.5691 23.3619 12.2331 19.5979V19.5973ZM8.06583 27.2936C5.51148 27.9996 4.50342 28.806 3.79748 29.3775C3.32705 29.7136 3.22595 29.848 2.88993 29.848C2.4195 29.512 1.98238 26.8232 1.98238 24.4372C1.98238 17.7489 5.20876 9.17887 7.89752 9.17887C9.54432 9.17887 10.2164 11.2628 10.2164 15.7661C10.2164 17.144 10.3508 18.522 10.5524 19.7989C10.8551 23.9328 10.9556 26.4872 8.06523 27.2936H8.06583Z",
    fill: "#FF669B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6937 24.4065C27.6937 18.4914 24.6689 7.2998 19.9973 7.2998C15.8634 7.2998 15.8634 13.4166 15.8634 15.7354C15.8634 16.979 15.729 18.2897 15.6618 19.5333C15.1913 23.3312 14.7542 27.734 19.2242 29.0109C21.4086 29.7168 22.249 30.2544 22.921 30.7249C23.4925 31.1953 24.0974 31.5313 25.0049 31.5313C25.4753 31.5313 25.9125 31.3297 26.2485 30.9598C27.6937 29.6157 27.6937 25.2463 27.6937 24.4059V24.4065ZM24.9044 29.8512C24.5684 29.8512 24.434 29.7168 23.8625 29.3808C23.1565 28.8093 22.1485 28.0028 19.5941 27.2969C16.7037 26.4904 16.8381 24.0705 17.2753 19.8021C17.4097 18.4242 17.6113 17.1473 17.6113 15.7693C17.6113 14.3913 17.6113 12.4085 18.0817 11.0305C18.5521 9.38372 19.3253 9.18211 19.9301 9.18211C22.4845 9.18211 25.8453 17.7188 25.8453 24.4404C25.8453 26.8264 25.3748 29.4819 24.9044 29.8512Z",
    fill: "#FF669B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1651 15.3954C15.9635 15.3954 15.2575 15.3954 14.7871 13.8831C14.6527 13.547 14.3167 13.3115 13.9807 13.3115C13.6446 13.3115 13.2747 13.5131 13.1742 13.8831C12.6027 15.3954 11.9306 15.3954 11.7962 15.3954C11.3258 15.3954 10.8887 15.8659 10.8887 16.303C10.8887 16.7734 11.3591 17.2105 11.7962 17.2105C12.5022 17.2105 13.3086 17.0089 14.1151 16.0342C14.821 16.9417 15.7619 17.2105 16.4339 17.2105C16.9043 17.2105 17.3414 16.7401 17.3414 16.303C17.0726 15.7654 16.6355 15.3954 16.1651 15.3954Z",
    fill: "#FF669B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8118 4.00488C13.3414 4.00488 12.9043 4.3409 12.9043 4.91243V14.39C12.9043 14.8604 13.3747 15.2975 13.8118 15.2975C14.2823 15.2975 14.7194 14.8271 14.7194 14.39V4.91243C14.7866 4.47531 14.3162 4.00488 13.8118 4.00488Z",
    fill: "#FF669B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2207_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 7,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4319 7.22656H20.9043V18.7541H32.4319V7.22656Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2207_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9614 12.5361H21.3747C21.072 12.5361 20.9043 12.7044 20.9043 13.0066C20.9043 13.3087 21.0726 13.477 21.3747 13.477H31.9614C32.2642 13.477 32.4319 13.3087 32.4319 13.0066C32.4319 12.7044 32.2303 12.5361 31.9614 12.5361Z",
    fill: "#FF669B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2207_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 23,
    width: 8,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4318 23.5825H25.4414V35.9843H32.4318V23.5825Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2207_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1297 28.8247H25.7441C25.5758 28.8247 25.4414 28.993 25.4414 29.2951C25.4414 29.5973 25.5758 29.7656 25.7441 29.7656H32.1297C32.298 29.7656 32.4324 29.5973 32.4324 29.2951C32.4324 29.0596 32.298 28.8247 32.1297 28.8247Z",
    fill: "#FF669B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2207_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 20,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4316 0H13.8125V11.5276H32.4316V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2207_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.659 5.27441H14.5856C14.1152 5.27441 13.8125 5.44272 13.8125 5.74484C13.8125 6.04696 14.1152 6.21527 14.5856 6.21527H31.659C32.1295 6.21527 32.4322 6.04696 32.4322 5.74484C32.4322 5.50933 32.1295 5.27441 31.659 5.27441Z",
    fill: "#FF669B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2207_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 9,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4309 16.0913H24.0625V26.8463H32.4309V16.0913Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2207_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0948 21.0005H24.4317C24.2301 21.0005 24.0957 21.1688 24.0957 21.4376C24.0957 21.7064 24.2301 21.8747 24.4317 21.8747H32.0948C32.2964 21.8747 32.4308 21.7064 32.4308 21.4376C32.4308 21.1688 32.2964 21.0005 32.0948 21.0005Z",
    fill: "#FF669B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramsFilter);
export default __webpack_public_path__ + "static/media/DiagramsFilter.81eefe0460a73b7bd9d665e050c29ab9.svg";
export { ForwardRef as ReactComponent };